import { z } from 'my-zod'
import { vehicleUseHistorySystemView } from './vehicle-use-history-system-view'
import { productLineOptions } from '../../internal'

const vehicleCheckInInputView = vehicleUseHistorySystemView.augment({
  checkInCustomerBase64Signature: z.string().nullable(),
  checkInStaffBase64Signature: z.string().nullable(),
  productLine: z.enum(productLineOptions).nullable(),
  operatorId: z.number().nullable()
})

export type vehicleCheckInInputView = z.infer<typeof vehicleCheckInInputView>
